module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-wrapper"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('input', {
    staticClass: "search-input",
    attrs: {
      "id": _vm.idSearchInput
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mapLeaf",
    attrs: {
      "id": _vm.idMap
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "basemap-button"
  }, [_c('img', {
    staticClass: "basemap-button-img",
    attrs: {
      "id": _vm.idBasemapSat,
      "src": require("../../assets/img/satellite_icon.jpg")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setBaseLayer('sat')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "basemap-button-img",
    attrs: {
      "id": _vm.idBasemapOsm,
      "src": require("../../assets/img/map_icon.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setBaseLayer('osm')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cursor-location"
  }, [(_vm.cursor_location) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.cursor_location.lat.toFixed(5)) + ", " + _vm._s(_vm.cursor_location.lng.toFixed(5)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "centre_marker",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setMarkerCentre()
      }
    }
  }, [_vm._v("\n            CenterMarker\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Latitude:")]), _vm._v(" "), (_vm.marker_lat) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.marker_lat),
      expression: "marker_lat",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "type": "number",
      "min": "-90",
      "max": "90"
    },
    domProps: {
      "value": (_vm.marker_lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.marker_lat = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Longitude:")]), _vm._v(" "), (_vm.marker_lng) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.marker_lng),
      expression: "marker_lng",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "type": "number",
      "min": "-180",
      "max": "180"
    },
    domProps: {
      "value": (_vm.marker_lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.marker_lng = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be634c84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/map_location.vue
// module id = 1046
// module chunks = 0